export const previewOrigin = process.env.REACT_APP_PREVIEW_ORIGIN || window.location.origin;

export const previewUrl = (path) => `${previewOrigin}${path.startsWith('/') ? path : `/${path}`}`;

export const iframeOrigin = (iframe) => {
  try {
    const src = iframe?.getAttribute('src') || iframe?.src || '';
    return new URL(src, window.location.href).origin;
  } catch (_error) {
    return previewOrigin;
  }
};
